import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

const SelectOptionsPaises = ({ className, name, id, optDefault, onChange }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + 'paises')
      .then(function (response) {
        const res = response.data
        setOptions(res)
      })
      .catch(function (error) {
        console.log(error)
      })
  }, [])

  return (
    <select name={name} id={id}
      onChange={onChange}
      className={className}
      defaultValue={''}
    >
      <option
        key={1}
        value=''
        disabled
      >
        {optDefault}
      </option>
      {options.map((option, x) => (
        <option
          key={x}
          value={option.name}
        >
          {option.name}
        </option>
      ))}
    </select>
  )
}

SelectOptionsPaises.propTypes = {
  className: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  optDefault: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export { SelectOptionsPaises }
